// Functions to handle animation states and directions
var isAnimationComplete = false; // Setting the default complete state of the animation to false

function handleAnimationComplete() {
    isAnimationComplete = true; // Set flag when the animation is done
}

function playForward(animation) {
    animation.setDirection(1); // Set direction to forward
    animation.play(); // Play the animation
    isAnimationComplete = false; // Reset complete flag
}

function playBackward(animation) {
    animation.setDirection(-1); // Set direction to reverse
    animation.play(); // Play backward
}

function playBackwardIfNotComplete(animation) {
    if (!isAnimationComplete) { // Only play backward if animation is not complete
        animation.setDirection(-1); // Set direction to reverse
        animation.play(); // Play backward
    }
}

function resetAnimation(animation) {
    animation.goToAndStop(0, true); // Reset to the beginning
    isAnimationComplete = false; // Reset flag
}

function loadLottieAnimation() {
    // Select only elements with the 'hoverReverseAnimation' class
    document.querySelectorAll('.hoverReverseAnimation').forEach(function(animationContainer) {
        // Ensure the animation container hasn't already been initialized
        if (animationContainer && !animationContainer.dataset.animationInitialized) {
            var animation2 = lottie.loadAnimation({
                container: animationContainer,
                renderer: 'svg',
                loop: false,
                autoplay: false,
                path: animationContainer.dataset.animationPath // Reference JSON dynamically
            });

            // Mark the animation as initialized
            animationContainer.dataset.animationInitialized = 'true';

            // Look for the animation trigger within the same container
            var container2 = animationContainer.closest('.animationTrigger');
            if (container2) {
                container2.addEventListener('mouseenter', function() {
                    playForward(animation2); // Play forward on hover
                });

                container2.addEventListener('mouseleave', function() {
                    playBackward(animation2); // Play backward on mouse leave
                });
            } else {
                console.error('Animation trigger element not found for:', animationContainer);
            }
        } else {
            console.warn('Animation container already initialized or not found:', animationContainer);
        }
    });

    // Select only elements with the 'loopingAnimation' class
    document.querySelectorAll('.loopingAnimation').forEach(function(animationContainer) {
        // Ensure the animation container hasn't already been initialized
        if (animationContainer && !animationContainer.dataset.animationInitialized) {
            var animation2 = lottie.loadAnimation({
                container: animationContainer,
                renderer: 'svg',
                loop: true,
                autoplay: true,
                path: animationContainer.dataset.animationPath // Reference JSON dynamically
            });
        } else {
            console.warn('Animation container already initialized or not found:', animationContainer);
        }
    });

     // Select only elements with the 'loopingAnimation' class
     document.querySelectorAll('.onceAnimation').forEach(function(animationContainer) {
        // Ensure the animation container hasn't already been initialized
        if (animationContainer && !animationContainer.dataset.animationInitialized) {
            var animation2 = lottie.loadAnimation({
                container: animationContainer,
                renderer: 'svg',
                loop: false,
                autoplay: true,
                path: animationContainer.dataset.animationPath // Reference JSON dynamically
            });
        } else {
            console.warn('Animation container already initialized or not found:', animationContainer);
        }
    });   
}

document.addEventListener('DOMContentLoaded', function() {
    loadLottieAnimation();
});